import React from 'react';
import PropTypes from 'prop-types';
import {GridItem} from '../components/shared/render';
import RenderToolCard from '../components/tool-card/render';

const NameCard = ({tools, navigate, isStuck, contactEnabledTools, stackupPath, currentUser}) => {
  return (
    <>
      <GridItem style={{border: 0, padding: '0 10px 0 10px', marginBottom: 15}}>
        <RenderToolCard
          tools={tools}
          index={0}
          minimal={false}
          navigate={navigate}
          focus={!isStuck}
          onAddClick={null}
          contactEnabledTools={contactEnabledTools}
          stackupPath={stackupPath}
          tooltip={false}
          userIsAdmin={currentUser && currentUser.amIAdmin}
          triggerEvent={true}
        />
      </GridItem>
      <GridItem style={{border: 0, padding: '0 10px 0 10px', marginBottom: 15}}>
        <RenderToolCard
          tools={tools}
          index={1}
          minimal={false}
          navigate={navigate}
          focus={!isStuck}
          onAddClick={null}
          contactEnabledTools={contactEnabledTools}
          stackupPath={stackupPath}
          tooltip={false}
          userIsAdmin={currentUser && currentUser.amIAdmin}
          triggerEvent={true}
        />
      </GridItem>
      <GridItem style={{border: 0, padding: '0 10px 0 10px', marginBottom: 15}}>
        <RenderToolCard
          tools={tools}
          index={2}
          minimal={false}
          navigate={navigate}
          focus={!isStuck}
          onAddClick={null}
          contactEnabledTools={contactEnabledTools}
          stackupPath={stackupPath}
          tooltip={false}
          userIsAdmin={currentUser && currentUser.amIAdmin}
          triggerEvent={true}
        />
      </GridItem>
    </>
  );
};

NameCard.propTypes = {
  tools: PropTypes.array,
  isStuck: PropTypes.any,
  navigate: PropTypes.func,
  contactEnabledTools: PropTypes.any,
  stackupPath: PropTypes.any,
  currentUser: PropTypes.object
};

export default NameCard;
